import http from "../http-common";
class MedecinDataService {
  medrdv(email) {
    return http.get(`/medecin/medrdv?email=${email}`);
  }
}
export default new MedecinDataService();